import { FileCsv } from '@emotion-icons/fa-solid/FileCsv'
import { useState } from 'react'
import { useRecoilValue } from 'recoil'
import { ButtonWithIcon } from 'src/components/button/button-with-icon'
import { Spinner } from 'src/components/spinner'
import { Colors } from 'src/components/theme'
import { DarkTooltip } from 'src/components/tooltip/dark-tooltip'
import { useDownloadLimit } from 'src/views/insight-download/use-limit-downloads'

import * as userAtoms from 'src/atoms/user'

type ButtonDownloadCSVProps = {
  onDownload: () => Promise<void>
  showText?: boolean
}
export const ButtonDownloadCSV = (props: ButtonDownloadCSVProps) => {
  const { onDownload, showText } = props
  const [loading, setLoading] = useState(false)
  const isTrial = useRecoilValue(userAtoms.isTrial)
  const { downloadsLeft, limitReached, onDecrementDownloads } = useDownloadLimit('csv')

  const onClick = async () => {
    if (loading || limitReached) {
      return
    }

    try {
      setLoading(true)
      await onDownload()
    } catch (e) {
      console.error(e)
    } finally {
      setLoading(false)
      onDecrementDownloads()
    }
  }

  return (
    <DarkTooltip
      placement="top"
      title={
        isTrial
          ? limitReached
            ? 'You have reached the download limit'
            : `You have (${downloadsLeft}) CSV downloads remaining in your trial`
          : 'Download CSV'
      }>
      <span>
        <ButtonWithIcon inverted disabled={loading || (isTrial && limitReached)} ghost onClick={onClick}>
          {showText && 'Download CSV'}
          {loading ? <Spinner style={{ color: Colors.textWhite }} size={16} /> : <FileCsv size={16} />}
        </ButtonWithIcon>
      </span>
    </DarkTooltip>
  )
}

export const ButtonDownloadCSVFallback = () => {
  return (
    <ButtonWithIcon inverted disabled ghost>
      <FileCsv size={16} />
    </ButtonWithIcon>
  )
}
